import { render, staticRenderFns } from "./WebCentrix.vue?vue&type=template&id=5f1238cc"
import script from "./WebCentrix.vue?vue&type=script&lang=js"
export * from "./WebCentrix.vue?vue&type=script&lang=js"
import style0 from "./WebCentrix.vue?vue&type=style&index=0&id=5f1238cc&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports